import { Social } from 'functions/src/types/Social';
export const PAGE_OBJECTS: { name: string; url: string }[] = [
  // {
  //   name: 'Games',
  //   url: '/#games',
  // },
  // {
  //   name: "What's New?",
  //   url: '/#listings',
  // },
  // {
  //   name: 'BLU Collection',
  //   url: '/blu-collection',
  // },
  // {
  //   name: 'About Us',
  //   url: '/about',
  // },
];

export const MENU_ITEMS: {
  title: string;
  link: string;
  type: 'menuItem';
  comingSoon?: boolean;
}[] = [
  { title: 'Games', link: '/#games' },
  { title: 'Items', link: '/#listings' },
  { title: 'About', link: '/about', comingSoon: true },
  { title: 'Blu Collection', link: '/blu-collection', comingSoon: true },
  { title: 'Contact Us', link: '/contact' },
].map((x) => {
  return { ...x, type: 'menuItem' };
});

export const SOCIALS: Social[] = [
  {
    name: 'twitter',
    link: 'https://twitter.com/blumint_',
  },
  {
    name: 'discord',
    link: 'https://discord.gg/QfcJRBkrGX',
  },
  {
    name: 'youtube',
    link: 'https://www.youtube.com/@blumintyt',
  },
  {
    name: 'instagram',
    link: 'https://www.instagram.com/blumint_games/',
  },
  {
    name: 'facebook',
    link: 'https://www.facebook.com/profile.php?id=100088937487677',
  },
  {
    name: 'twitch',
    link: 'https://www.twitch.tv/blumint_official_1',
  },
  {
    name: 'tiktok',
    link: 'https://www.tiktok.com/@blumint_official?is_from_webapp=1&sender_device=pc',
  },
];
